module.exports = __webpack_public_path__ + "img/risk-management.daa14316.png";